import { PublicClientApplication, LogLevel, EventType } from "@azure/msal-browser";

// Build-time replaced by Bun's define plugin; falls back to test/staging app in dev
declare const __MSAL_CLIENT_ID__: string | undefined;
const msalClientId = typeof __MSAL_CLIENT_ID__ !== "undefined"
  ? __MSAL_CLIENT_ID__
  : "500cbdcd-64e4-4d14-9bbe-8d72cfcde156";

const msalConfig = {
  auth: {
    clientId: msalClientId,
    // Multi-tenant: use "common" since signInAudience is AzureADMultipleOrgs
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // localStorage is shared across tabs/windows for the same origin, so links that
    // open in a new window (e.g. the PSE previous-application links) stay signed in.
    // sessionStorage would be per-tab and bounce those new tabs to /login.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

// Scopes for the CMS backend API
export const apiScopes = {
  scopes: ["api://e6e8935b-cdfa-4efd-a8a7-3db647917115/BenefitApplications.ReadWrite.All"],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Ensure MSAL is fully initialized and redirect response is handled before app renders
export const msalReady = msalInstance.initialize().then(async () => {
  const response = await msalInstance.handleRedirectPromise();
  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  }

  // If no active account is set but accounts exist, use the first one
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0] ?? null);
  }
});
